<template>
    <div class="layui-row layui-col-space24" v-if="aPic.length>2">
        <div class="layui-col-xs12 layui-col-sm12 layui-col-lg6 top-video">
            <div class="">
                <!-- <img src="/assets/img/index_visits_school.png" /> -->
                <iframe class="iframe" v-if="refVideo" :src="myUtils.getUrlVideo(refVideo)" scrolling="no" border="0" frameborder="no" framespacing="0"
                    allowfullscreen="true"></iframe>
                <div v-if="!refVideo" class="iframe x-imgbox">
                    <img  :alt="props.data.data.attributes.name + '语言学校的介绍照片'"  :src="myUtils.getUrlPic(aPic[0], 'medium')" />
                </div>
                <!-- <img class="x-play" src="assets/img/index_visits_play.svg" /> -->
            </div>
        </div>
        <div class="layui-col-xs12 layui-col-sm12 layui-col-lg6">
            <div class="layui-row  layui-col-space16 top-imgs">
                <div class="layui-col-xs6" v-for="(item, index) in aPic.slice(refVideo?0:1, refVideo?4:5)" :key="index">
                    <div class="x-imgbox">
                        <img  :alt="props.data.data.attributes.name + '语言学校的介绍照片'"  :src="myUtils.getUrlPic(item, 'medium')" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<script setup>
const props = defineProps({
    data: Object
})

const refVideo = ref("");
let video = props.data.data.attributes.video;
refVideo.value = video;

const aPic = ref([]);
try {
    aPic.value = props.data.data.attributes.pictures.data || [];
} catch (e) { }




</script>



<style scoped>
.top-video .iframe {
    width: 100%;
}

.top-video .iframe {
    height: 240px;
}

.top-imgs .x-imgbox {
    height: 130px;
}

@media screen and (min-width: 768px) {
    .top-video .iframe {
        height: 380px;
    }

    .top-imgs .x-imgbox {
        height: 167px;
    }
}

@media screen and (min-width: 1200px) {
    .top-video .iframe {
        height: 351px;
    }
}
</style>

